// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3kH1z","containerItemsCenter":"Skeleton_containerItemsCenter__LSm8y"};